import { render, staticRenderFns } from "./CopyLink.vue?vue&type=template&id=16461e7c&scoped=true"
import script from "./CopyLink.vue?vue&type=script&lang=js"
export * from "./CopyLink.vue?vue&type=script&lang=js"
import style0 from "./CopyLink.vue?vue&type=style&index=0&id=16461e7c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16461e7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16461e7c')) {
      api.createRecord('16461e7c', component.options)
    } else {
      api.reload('16461e7c', component.options)
    }
    module.hot.accept("./CopyLink.vue?vue&type=template&id=16461e7c&scoped=true", function () {
      api.rerender('16461e7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/coupon/list/modules/CopyLink.vue"
export default component.exports